import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
import type { ModalDescriptionProps } from './Modal.types';
const baseClassName = ['group-[.sm]/modal:text-base', 'group-[.drawer]/modal:text-sm', 'text-greyscale-950'];
const Description = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(baseClassName, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <p className={t1} {...props}>{children}</p>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Description;